import listFormatterItemRenderer from './list_formatter_item_renderer';
import styles from 'src/js/common/components/formatters/ListFormatter.less';
import baseListFormatterParams from 'src/js/lib/raw_rendering/base_list_formatter_params';

/**
 * Returns raw Html version of MarkerListFormatter component.
 * @param params
 * @param services
 * @returns {String}
 */
export default function listFormatter(params, services = {}) {
  const {ownValue} = baseListFormatterParams(params);
  return ownValue
    ? `<div class="${styles.dlListFormatter}">
            ${
              ownValue &&
              ownValue
                .map((item) => listFormatterItemRenderer({item}, services))
                .join('')
            }
        </div>`
    : '';
}
